import { BasePostRequest } from './core/basePostRequest';
import { SharingType } from 'acscp/store';
import * as t from 'io-ts';
import { Authentication } from './core/baseRequest';
import { LocaleCode } from 'acscp/translations';

export class ShareRequest extends BasePostRequest<undefined> {
    constructor(public bookingId: string, public emails: string[], public sharingTypes: SharingType[], public defaultLanguage: LocaleCode) {
        super(
            `bookings/${bookingId}/share`,
            {},
            { emails, types: sharingTypes, language: defaultLanguage },
            t.undefined,
            Authentication.Login
        );
    }
}
